import { memo } from 'react';
import { ISection } from 'src/interface';
import { renderSections } from 'src/modules/shared/components/sections';
import { EventSoccer } from './sections';

interface IProps {
    sections: ISection<any>[];
}

export enum TOP_SECTION_ID {
    EVENT_SOCCER = 210,
}

export const SECTION_MAP = {
    [TOP_SECTION_ID.EVENT_SOCCER]: EventSoccer,
};

export function SectionTop({ sections }: IProps) {
    return <>{renderSections(sections, SECTION_MAP)}</>;
}

export default memo(SectionTop);
